import { ChatMessageStatus } from '@pages/home/main-layout/main-layout.model';

const MESSAGE_TYPES = {
  PLAN: {
    content: JSON.stringify({
      header: {
        icon: 'database',
        title: 'Create Data Model and Pages'
      },
      description: 'Here are the proposed Data Model and Pages to be added. Would you like to proceed? #MOCK',
      artifacts: {
        datamodel: {
          create: [
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'New table 1',
                tableFields: [
                  {
                    fieldName: 'Field1',
                    fieldType: 'String'
                  },
                  { fieldName: 'Field2', fieldType: 'String' },
                  { fieldName: 'Field3', fieldType: 'Boolean' },
                  { fieldName: 'Field4', fieldType: 'Text' },
                  { fieldName: 'Field5', fieldType: 'Date' },
                  { fieldName: 'Field6', fieldType: 'Number' },
                  { fieldName: 'Field7', fieldType: 'String' },
                  { fieldName: 'Field8', fieldType: 'String' },
                  { fieldName: 'Field9', fieldType: 'Boolean' },
                  { fieldName: 'Field10', fieldType: 'Text' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'New table 2',
                tableFields: [
                  { fieldName: 'Field1', fieldType: 'Integer' },
                  { fieldName: 'Field2', fieldType: 'String' },
                  { fieldName: 'Field3', fieldType: 'Boolean' },
                  { fieldName: 'Field4', fieldType: 'Text' },
                  { fieldName: 'Field5', fieldType: 'Date' },
                  { fieldName: 'Field6', fieldType: 'Float' },
                  { fieldName: 'Field7', fieldType: 'String' },
                  { fieldName: 'Field8', fieldType: 'String' },
                  { fieldName: 'Field9', fieldType: 'Boolean' },
                  { fieldName: 'Field10', fieldType: 'Text' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'New table 3',
                tableFields: [
                  { fieldName: 'Field1', fieldType: 'Integer' },
                  { fieldName: 'Field2', fieldType: 'String' },
                  { fieldName: 'Field3', fieldType: 'Boolean' },
                  { fieldName: 'Field4', fieldType: 'Text' },
                  { fieldName: 'Field5', fieldType: 'Date' },
                  { fieldName: 'Field6', fieldType: 'Float' },
                  { fieldName: 'Field7', fieldType: 'String' },
                  { fieldName: 'Field8', fieldType: 'String' },
                  { fieldName: 'Field9', fieldType: 'Boolean' },
                  { fieldName: 'Field10', fieldType: 'Text' }
                ]
              }
            }
          ],
          update: [
            {
              targetId: 'Existing table 1',
              type: 'TABLE',
              payload: {
                tableFields: {
                  add: [
                    {
                      fieldName: 'new_field_1',
                      fieldType: 'TEXT'
                    },
                    {
                      fieldName: 'new_field_2',
                      fieldType: 'BOOLEAN'
                    },
                    {
                      fieldName: 'new_field_3',
                      fieldType: 'DATE'
                    }
                  ]
                }
              }
            },
            {
              targetId: 'Existing table 2',
              type: 'TABLE',
              payload: {
                tableFields: {
                  update: [
                    {
                      fieldName: 'existing_field_6',
                      changes: {
                        fieldType: 'DATE'
                      }
                    },
                    {
                      fieldName: 'existing_field_28',
                      changes: {
                        fieldName: 'EXISTING FIELD 28'
                      }
                    }
                  ]
                }
              }
            },
            {
              targetId: 'Existing table 3',
              type: 'TABLE',
              payload: {
                tableFields: {
                  delete: ['existing_field_5', 'existing_field_7']
                }
              }
            },
            {
              targetId: 'Existing table 4',
              type: 'TABLE',
              payload: {
                changes: {
                  tableName: 'Existing table FOUR'
                },
                tableFields: {
                  add: [
                    {
                      fieldName: 'new_field_1',
                      fieldType: 'TEXT'
                    }
                  ],
                  update: [
                    {
                      fieldName: 'existing_field_6',
                      changes: {
                        fieldType: 'DATE'
                      }
                    },
                    {
                      fieldName: 'existing_field_28',
                      changes: {
                        fieldType: 'BOOLEAN'
                      }
                    }
                  ]
                }
              }
            },
            {
              targetId: 'Existing table 5',
              type: 'TABLE',
              payload: {
                tableFields: {
                  delete: ['existing_field_5'],

                  add: [
                    {
                      fieldName: 'new_field_1',
                      fieldType: 'TEXT'
                    }
                  ],
                  update: [
                    {
                      fieldName: 'existing_field_6',
                      changes: {
                        fieldType: 'DATE'
                      }
                    },
                    {
                      fieldName: 'existing_field_28',
                      changes: {
                        fieldType: 'BOOLEAN'
                      }
                    }
                  ]
                }
              }
            }
          ],
          delete: ['existing_table_77', 'existing_table_24']
        },
        page: {
          create: [
            {
              payload: {
                screenName: 'Purchase Invoice',
                screenType: 'list',
                tableName: 'task'
              }
            },
            {
              payload: {
                screenName: 'Purchase Invoice',
                screenType: 'detail',
                tableName: 'task'
              }
            },
            {
              payload: {
                screenName: 'Sales Invoice',
                screenType: 'list',
                tableName: 'task'
              }
            },
            {
              payload: {
                screenName: 'Sales Invoice',
                screenType: 'detail',
                tableName: 'task'
              }
            }
          ]
        }
      }
    }),
    actions: JSON.stringify([
      {
        label: 'Reject REV',
        code: 'reject',
        renderAsIcon: 'true'
      },
      {
        label: 'Refine REV',
        code: 'refine',
        align: 'right'
      },
      {
        label: 'Accept REV',
        code: 'accept',
        align: 'right'
      }
    ]),
    primaryAction: 'accept',
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1',
    _isMockResponse: 'true',
    status: ChatMessageStatus.PENDING,
    messageType: 'plan',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: '874a54f0-ab59-456a-b83b-99a5ffd1ad33',
    appId: 'app1'
  },
  PLAN_DMV: {
    content: JSON.stringify({
      header: {
        icon: 'database',
        title: 'Create Data Model (DMV)'
      },
      description: 'Here are the proposed Data Model and Pages to be added. Would you like to proceed? #MOCK',
      artifacts: {
        datamodel: {
          create: [
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'client 12',
                tableFields: [
                  { fieldName: 'c12_f_1', fieldType: 'string' },
                  { fieldName: 'c12_f_2', fieldType: 'string' },
                  { fieldName: 'c12_f_3', fieldType: 'string' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'client 13',
                tableFields: [
                  { fieldName: 'Sid', fieldType: 'string' },
                  { fieldName: 'Created By', fieldType: 'string' },
                  { fieldName: 'Created Date', fieldType: 'date time' },
                  { fieldName: 'Modified By', fieldType: 'string' },
                  { fieldName: 'Modified Date', fieldType: 'date time' },
                  { fieldName: 'c13_f_1', fieldType: 'string' },
                  { fieldName: 'c13_f_2', fieldType: 'string' },
                  { fieldName: 'c13_f_3', fieldType: 'string' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'client 14',
                tableFields: [
                  { fieldName: 'Sid', fieldType: 'string' },
                  { fieldName: 'Created By', fieldType: 'string' },
                  { fieldName: 'Created Date', fieldType: 'date time' },
                  { fieldName: 'Modified By', fieldType: 'string' },
                  { fieldName: 'Modified Date', fieldType: 'date time' },
                  { fieldName: 'c14_f_1', fieldType: 'string' },
                  { fieldName: 'c14_f_2', fieldType: 'string' },
                  { fieldName: 'c14_f_3', fieldType: 'string' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'Data Types Test',
                tableFields: [
                  { fieldName: 'Sid', fieldType: 'String' },
                  { fieldName: 'string_col', fieldType: 'String' },
                  { fieldName: 'number_col', fieldType: 'Number' },
                  { fieldName: 'bool_col', fieldType: 'Boolean' },
                  { fieldName: 'date_col', fieldType: 'DateTime' },
                  { fieldName: 'drop_col', fieldType: 'Dropdown' },
                  { fieldName: 'email_col', fieldType: 'Email' }
                ]
              }
            },
            {
              targetId: 'client 1',
              type: 'TABLE',
              payload: {
                tableFields: [
                  { fieldName: 'new_mock_field_1', fieldType: 'string' },
                  { fieldName: 'new_mock_field_2', fieldType: 'number' }
                ]
              }
            },
            {
              targetId: 'client 2',
              type: 'TABLE',
              payload: {
                tableFields: {
                  add: [{ fieldName: 'new_c2_field_1', fieldType: 'string' }]
                }
              }
            }
          ],
          update: [
            {
              targetId: 'client 8',
              type: 'TABLE',
              payload: {
                changes: {
                  tableName: 'client Neo EIGHT'
                }
              }
            },
            {
              targetId: 'client 5',
              type: 'TABLE',
              payload: {
                tableFields: {
                  update: [
                    { fieldName: 'Created By', changes: { fieldName: 'Cby', fieldType: 'String' } },
                    { fieldName: 'c5_f_3', changes: { fieldName: 'CDT', fieldType: 'Date Time' } }
                  ]
                }
              }
            },
            {
              targetId: 'client 1',
              type: 'TABLE',
              payload: {
                tableFields: {
                  update: [{ fieldName: 'Created By', changes: { fieldName: 'CreatedBy_v2', fieldType: 'String' } }],
                  delete: ['Modified By', 'Modified Date']
                }
              }
            },
            {
              targetId: 'client 2',
              type: 'TABLE',
              payload: {
                tableFields: {
                  update: [{ fieldName: 'Modified By', changes: { fieldName: 'ModifiedBy_v2', fieldType: 'String' } }],
                  delete: ['Created By', 'Created Date']
                }
              }
            },
            {
              targetId: 'client 8',
              type: 'TABLE',
              payload: {
                tableFields: {
                  update: [{ fieldName: 'Modified By', changes: { fieldName: 'ModifiedBy_v2', fieldType: 'String' } }]
                }
              }
            }
          ],
          delete: ['client 3', 'client 4']
        }
      }
    }),
    actions: JSON.stringify([
      {
        label: 'Reject',
        code: 'reject',
        renderAsIcon: 'true'
      },
      {
        label: 'Refine',
        code: 'refine',
        align: 'right'
      },
      {
        label: 'Accept',
        code: 'accept',
        align: 'right'
      }
    ]),
    primaryAction: 'accept',
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1',
    _isMockResponse: 'true',
    status: ChatMessageStatus.PENDING,
    messageType: 'plan',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: '874a54f0-ab59-456a-b83b-99a5ffd1ad33',
    appId: 'app1'
  },
  PLAN_DMV_V2: {
    content: JSON.stringify({
      header: {
        icon: 'database',
        title: 'Create Data Model (DMV)'
      },
      description:
        'Here are the proposed Data Model and Pages to be added. Would you like to proceed? Here are the proposed Data Model and Pages to be added. Would you like to proceed? Here are the proposed Data Model and Pages to be added. Would you like to proceed? Here are the proposed Data Model and Pages to be added. Would you like to proceed? Here are the proposed Data Model and Pages to be added. Would you like to proceed? Here are the proposed Data Model and Pages to be added. Would you like to proceed? #MOCK',
      artifacts: {
        datamodel: {
          create: [
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'client 12',
                tableFields: [
                  { fieldName: 'c12_f_1', fieldType: 'string' },
                  { fieldName: 'c12_f_2', fieldType: 'string' },
                  { fieldName: 'c12_f_3', fieldType: 'string' }
                ]
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'client 121',
                tableType: 'transactional_+_analytical',
                tableFields: [
                  { fieldName: 'c12_f_1', fieldType: 'string' },
                  { fieldName: 'c12_f_2', fieldType: 'string' },
                  { fieldName: 'c12_f_3', fieldType: 'string' }
                ]
              }
            },
            {
              targetId: 'client 2',
              type: 'TABLE',
              payload: {
                tableFields: {
                  add: [{ fieldName: 'new_c2_field_1', fieldType: 'string' }]
                }
              }
            },
            {
              targetId: '',
              type: 'TABLE',
              payload: {
                name: 'Product',
                tableType: 'TRANSACTIONAL_ONLY',
                tableFields: {
                  add: [
                    {
                      fieldName: 'productId',
                      fieldType: 'AUTONUMBER'
                    },
                    {
                      fieldName: 'productName',
                      fieldType: 'STRING'
                    },
                    {
                      fieldName: 'sku',
                      fieldType: 'STRING'
                    },
                    {
                      fieldName: 'category',
                      fieldType: 'DROPDOWN'
                    },
                    {
                      fieldName: 'unitPrice',
                      fieldType: 'CURRENCY'
                    },
                    {
                      fieldName: 'description',
                      fieldType: 'TEXT'
                    },
                    {
                      fieldName: 'status',
                      fieldType: 'DROPDOWN'
                    },
                    {
                      fieldName: 'manufacturer',
                      fieldType: 'STRING'
                    },
                    {
                      fieldName: 'weight',
                      fieldType: 'DOUBLE'
                    }
                  ]
                },
                tableIndexes: {
                  add: [
                    {
                      indexName: 'PK_Product_ProductId',
                      indexFields: ['productId'],
                      indexType: 'PRIMARY'
                    },
                    {
                      indexName: 'UK_Product_Sku',
                      indexFields: ['sku'],
                      indexType: 'UNIQUE'
                    }
                  ]
                },
                foreignKeys: {
                  add: []
                }
              }
            }
          ],
          delete: ['client 3', 'client 4']
        },
        page: {
          create: [
            {
              targetId: '',
              type: 'PAGE'
            }
          ]
        }
      }
    }),
    actions: JSON.stringify([
      {
        label: 'Stop',
        code: 'reject',
        align: 'left'
      },
      {
        label: 'Refine',
        code: 'refine',
        align: 'right'
      },
      {
        label: 'Accept',
        code: 'accept',
        align: 'right'
      }
    ]),
    primaryAction: 'accept',
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1_v2',
    _isMockResponse: 'true',
    status: ChatMessageStatus.PENDING,
    messageType: 'plan',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: 'mock-conversation-c1',
    appId: 'app1'
  },
  PLAN_OUTLINE: {
    content: JSON.stringify({
      header: {
        title: 'To-Do List App'
      },
      description: 'This is sample description text for plan',
      sections: [
        {
          title: 'Build plan',
          items: [
            {
              text: 'Create data table',
              status: 'successful'
            },
            {
              text: 'Create pages',
              status: 'in-progress'
            },
            {
              text: 'Build integrations',
              status: 'failed'
            }
          ]
        }
      ]
    }),
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1',
    _isMockResponse: 'true',
    status: 'in-progress', // in-progress, failed, successful
    messageType: 'plan_outline',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: 'mock-conversation-c1',
    appId: 'app1'
  },
  PLAN_OUTLINE_V2: {
    content: JSON.stringify({
      sections: [
        {
          title: 'Build plan',
          items: [
            {
              text: 'Create data table',
              status: 'successful'
            },
            {
              text: 'Create pages',
              status: 'in-progress'
            },
            {
              text: 'Build integrations',
              status: 'failed'
            },
            {
              text: 'status - open',
              status: 'pending'
            }
          ]
        }
      ]
    }),
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1',
    _isMockResponse: 'true',
    status: 'pending', // pending, failed, successful
    messageType: 'plan_outline',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: 'mock-conversation-c1',
    appId: 'app1'
  },
  AGENT_RESPONSE_LONG_CHECK_STREAMING_SPEED: {
    content: JSON.stringify({
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). #MOCK"
    }),
    sid: 'm2_AIResponse_CreateAppFlow_Acknowledgement',
    _isMockResponse: 'true',

    messageType: 'agent_response',
    isCollapsed: false,
    role: 'assistant',
    sessionId: 'session_id_' + new Date().getTime(),
    conversationId: 'conversation_id_' + new Date().getTime(),
    status: ChatMessageStatus.COMPLETED,

    appId: 'app_id_' + new Date().getTime()
  },
  AGENT_RESPONSE_1: {
    content: JSON.stringify({
      text: 'This is a sample message. #MOCK'
    }),
    sid: 'm1_AIResponse_CreateAppFlow_Acknowledgement',
    _isMockResponse: 'true',

    messageType: 'agent_response',
    isCollapsed: false,
    role: 'assistant',
    sessionId: 'session_id_' + new Date().getTime(),
    conversationId: 'conversation_id_' + new Date().getTime(),
    status: ChatMessageStatus.COMPLETED,

    appId: 'app_id_' + new Date().getTime()
  },
  AGENT_RESPONSE_2: {
    content: JSON.stringify({
      text: 'This is a sample message. #MOCK'
    }),
    sid: 'm2_AIResponse_CreateAppFlow_Acknowledgement',
    _isMockResponse: 'true',

    messageType: 'agent_response',
    isCollapsed: false,
    role: 'assistant',
    sessionId: 'session_id_' + new Date().getTime(),
    conversationId: 'conversation_id_' + new Date().getTime(),
    status: ChatMessageStatus.COMPLETED,

    appId: 'app_id_' + new Date().getTime()
  },
  PLAN_OUTLINE_BUILD_CONFIRMATION: {
    content: JSON.stringify({
      hideHeader: true,
      description: 'Do you want to build artifacts?'
    }),
    actions: JSON.stringify([
      { code: 'no', label: 'No' },
      { label: 'Yes', code: 'yes' }
    ]),
    primaryAction: 'yes',
    sid: 'm1s_AIResponse_CreateAppFlow_Acknowledgement_createApp_1',
    _isMockResponse: 'true',
    status: ChatMessageStatus.PENDING,
    messageType: 'plan_outline',
    role: 'assistant',
    sessionId: 'session1',
    conversationId: '874a54f0-ab59-456a-b83b-99a5ffd1ad33',
    appId: 'app1',
    sections: [
      {
        title: 'Todos',
        items: [
          {
            text: 'Develop Customer Management module',
            status: 'completed'
          },
          {
            text: 'Design Freight Management module',
            status: 'completed'
          },
          {
            text: 'Configure Quote module',
            status: 'open'
          }
        ]
      }
    ]
  },
  QUESTION_SETS_1: {
    role: 'user',
    sid: 'qna_set_1',
    messageType: 'qna',
    status: 'pending',
    content: JSON.stringify({
      questions: [
        {
          id: 'q1',
          type: 'textarea',
          text: 'In few sentences, what problem are you trying to solve and who will benefit from this new system?'
        },
        {
          id: 'q2',
          type: 'check-boxes',
          text: 'Which of these challenges are you currently facing in your day-to-day operations?',
          options: [
            { id: 'opt1', text: 'We rely on spreadsheets and phone calls to coordinate dispatches' },
            { id: 'opt2', text: 'Shipments get delayed and we find out too late' },
            { id: 'opt3', text: 'Billing discrepancies with carriers and customers are frequent' },
            { id: 'opt4', text: 'Our drivers lack a digital tool for trip updates and proof of delivery' },
            { id: 'opt5', text: 'We cannot accurately forecast fleet capacity or costs' },
            { id: 'opt6', text: 'Regulatory paperwork is scattered and hard to audit' },
            { id: 'opt7', text: "Different teams use different tools that don't talk to each other" }
          ]
        },
        {
          id: 'q3',
          type: 'chips',
          text: 'Which of these areas do you want the new system to handle?',
          options: [
            { id: 'opt1', text: 'Receiving and managing transport orders' },
            { id: 'opt2', text: 'Managing vehicles, maintenance, and documents' },
            { id: 'opt3', text: 'Planning optimal delivery routes' },
            { id: 'opt4', text: 'Assigning drivers and dispatching trips' },
            { id: 'opt5', text: 'Tracking shipments in real time' },
            { id: 'opt6', text: 'Calculating freight rates and charges' },
            { id: 'opt7', text: 'Generating invoices and reconciling payments' },
            { id: 'opt8', text: 'Connecting with warehouse operations' },
            { id: 'opt9', text: 'Handling permits, compliance, and audits' },
            { id: 'opt10', text: 'DB' },
            { id: 'opt11', text: 'Portal' }
          ]
        },
        {
          id: 'q4',
          type: 'radio-buttons',
          text: 'Where would you prefer this system to run?',
          options: [
            { id: 'opt1', text: 'Fully on the cloud, accessible from anywhere' },
            { id: 'opt2', text: 'On our own servers within the organization' },
            { id: 'opt3', text: 'A mix of cloud and on-premises' },
            { id: 'opt4', text: 'Cloud, but with dedicated tenant isolation' }
          ]
        },
        {
          id: 'q5',
          type: 'slider',
          text: 'How large is the fleet you plan to manage through this system?',
          config: {
            startRange: 10,
            endRange: 100,
            interval: 10,

            labels: {
              low: 'Under 50 vehicles',
              high: '5000+ vehicles'
            }
          }
        },
        {
          id: 'q6',
          type: 'yes-no',
          text: 'Are any of the following important for how the system should behave?',
          options: [
            { id: 'opt1', text: 'Must be available round the clock with minimal downtime' },
            { id: 'opt2', text: "Access should be restricted based on each person's role" },
            { id: 'opt3', text: 'Needs to work in multiple languages or regions' },
            { id: 'opt4', text: 'Drivers should be able to use the app even without internet' },
            { id: 'opt5', text: 'Every action in the system should be logged for audit' },
            { id: 'opt6', text: 'All data must be encrypted for security' }
          ]
        }
      ],
      answers: {
        q1: 'We are struggling with manual shipment tracking and rising freight costs. The new TMS will benefit our logistics team, dispatchers, and customers by streamlining end-to-end transportation operations.',
        q2: ['opt2', 'opt3'],
        q3: ['opt2', 'opt5', 'opt6'],
        q4: ['opt3'],
        q5: '8',
        q6: {
          opt1: 'true',
          opt3: 'true',
          opt4: 'false',
          opt5: 'false',
          opt6: 'true'
        }
      }
    })
  },
  QUESTION_SETS_2: {
    role: 'user',
    sid: 'qna_set_1',
    messageType: 'qna',
    status: 'pending',
    content: JSON.stringify({
      questions: [
        {
          id: 'q1',
          type: 'textarea',
          text: 'In few sentences, what problem are you trying to solve and who will benefit from this new system?'
        },
        {
          id: 'qb2',
          type: 'check-boxes',
          text: 'Which of these challenges are you currently facing in your day-to-day operations?',
          options: [
            { id: 'opt1', text: 'We rely on spreadsheets and phone calls to coordinate dispatches' },
            { id: 'opt2', text: 'Shipments get delayed and we find out too late' }
          ]
        }
      ],
      answers: {
        qb1: 'We are struggling with manual shipment tracking and rising freight costs.',
        qb2: ['opt2', 'opt3']
      }
    })
  },
  SHIMMER_1: {
    role: 'assistant',
    messageType: 'shimmer',
    sid: 'shimmer_mock_1',
    content: JSON.stringify({
      text: 'Configuring ideation workspace .. Configuring ideation workspace .. Configuring ideation workspace'
    })
  },
  SHIMMER_2: {
    role: 'assistant',
    messageType: 'shimmer',
    sid: 'shimmer_mock_2',
    content: JSON.stringify({
      text: 'Analyzing domain requirements',
      icon: 'file-question-02'
    }),
    delayBeforeRender: 3000
  },
  RECOMMENDATION: {
    role: 'user',
    sid: 'qna_set_1',
    messageType: 'recommendation',
    status: 'pending',
    content: JSON.stringify({
      questions: [
        {
          id: 'q1',
          type: 'radio-buttons',
          text: 'What would you like to focus on now?',
          options: [
            { id: 'opt1', text: 'Deep dive into Master-data module' },
            { id: 'opt2', text: 'Discover roles in app' },
            { id: 'opt3', text: 'Define NFRs' }
          ]
        }
      ]
    })
  }
};

export const getMockMessagePayload = (messageType: keyof typeof MESSAGE_TYPES) => {
  const payload = MESSAGE_TYPES[messageType];
  if (!payload) return null;

  return {
    ...payload,
    createdDate: new Date().getTime()
  };
};

/*

 changes: {
                name: "field name, if revised",
                fieldType: "field type, if revised
            }
*/
